<template>
    <!-- Mobile Details Modal -->
    <modal-side-generic
    :headerColor="headerColor"
    :title="title"
    :subTitle="subTitle"
    @hideMe="emit('hideMe')">
        <div v-for="(data, index) in parsedDetailsData" :key="`lineGroup${data.id}`" class="group-wrapper">
            <divider-generic icon="account-balance" :title="data.title" :applyBorder="index !== 0"/>
            <!-- Text Block for each line -->
            <text-block-generic
            v-for="line in data.lines"
            :key="`lineGroupLine${line.id}`"
            :params="line"
            :icon="line.icon"
            :colorIcon="line.colorIcon"
            applyEllipsis/>
        </div>
    </modal-side-generic>
</template>

<script setup>
import ModalSideGeneric from '@/components/generic/modals/side/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Aux */
import { amountFormat, currencyParser } from '@/assets/scripts/amounts'
import { accountFormatHelper } from '@/assets/scripts/strings'

/* Vue */
import { computed } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Props
@headerColor {String} - color for header
@title {String} - text to display in our title
@subTitle {String} - text to display under our title
@detailsData {Array} - details data
*/
const props = defineProps({
    headerColor: String,
    title: String,
	subTitle: String,
    detailsData: Array
})

const emit = defineEmits(['hideMe'])

const parsedDetailsData = computed(() => {
    return props.detailsData.map(data => ({
        id: data.id,
        title: accountFormatHelper(data.accountNumber),
        lines: [
            {
                id: 0,
                label: t('accounts.patrimony.mobile.details.accountName'),
                content: data.accountDescription
            },
            {
                id: 1,
                label: t('accounts.patrimony.mobile.details.availableBalance'),
                content: amountFormat(Math.abs(data.availableBalance), currencyParser(data.accountCurrency)),
                icon: data.availableBalance && data.availableBalance !== 0 ? data.availableBalance > 0 ? 'plus' : 'minus' : null,
                colorIcon: data.availableBalance > 0 ? 'var(--positive)' : 'var(--negative)',
                classes: 'amount-icon'
            },
            {
                id: 2,
                label: t('accounts.patrimony.mobile.details.balance'),
                content: amountFormat(Math.abs(data.balance), currencyParser(data.accountCurrency)),
                icon: data.balance && data.balance !== 0 ? data.balance > 0 ? 'plus' : 'minus' : null,
                colorIcon: data.balance > 0 ? 'var(--positive)' : 'var(--negative)',
                classes: 'amount-icon'
            },
            {
                id: 3,
                label: t('accounts.patrimony.mobile.details.percentageWeight'),
                content: data.percentage
            }
        ]
    }))
})
</script>

<style lang="scss" scoped>

</style>
